// Limite de vida (substituição do motor ou da hélice, overhaul, TBO, revisão geral): sem tolerância por defeito.
// Espelho de LIFE_LIMIT_PATTERN em backend/services/di_tolerance.py (é o servidor que decide; isto só mostra no
// formulário a mesma tolerância por defeito). Um teste do backend confirma que as duas expressões não divergem.
export const LIFE_LIMIT_RE = /\b(?:overhaul|tbo)\b|\brevisao geral\b|\bgrande revisao\b|\b(?:substituicao|troca)\s+(?:(?:do|da|de|dos|das)\s+)?(?:motor|helice)\b/;

const plain = (s) => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/\s+/g, " ").trim();

export const isLifeLimitName = (name) => LIFE_LIMIT_RE.test(plain(name));
